import React from 'react';
import { Box, Typography, CircularProgress, useTheme } from '@mui/material';
import PieChart from '../../components/ui/PieChart';
import { useStatusDistribution } from '../../hooks/useSubscriptions';

const SubscriptionStatusChart = () => {
    const theme = useTheme();
    const { data: distributionData, isLoading, error } = useStatusDistribution();

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={300}>
                <CircularProgress />
            </Box>
        );
    }

    if (error || !distributionData?.data) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={300}>
                <Typography color="error">Failed to load status distribution</Typography>
            </Box>
        );
    }

    const series = distributionData.data.map(item => item.count);
    const labels = distributionData.data.map(item => item.status);
    const colors = ['#00C49F', '#FF8042']; // Green for Active, Orange for Inactive

    return (
        <Box sx={{ height: '100%', width: '100%' }}>
            <PieChart series={series} labels={labels} colors={colors} />
        </Box>
    );
};

export default SubscriptionStatusChart;
